import './index.scss';
import dayjs from 'dayjs';
import Header from '../../../../../../../components/Header/Header';
import NoData from '../../../../../../../components/NoData/NoData';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { copyToClipboard, formatToNaira } from '../../../../../../../helpers/utils';
import { formatDate } from '../../../../../../../helpers/utils/date';
import { IoCopyOutline } from 'react-icons/io5';
import useSafeLock from '../../../../../../../hooks/useSafeLock';
import { FormattedSLData } from '../../../../../../../types';
import ModalExecuteAction from '../../../../../../../components/Modals/ModalExecuteAction';
import { authPayload } from '../../../../../../../helpers/utils/auth-payload';
import { localStorageEnum } from '../../../../../../../api/enums';
// import { useSelector } from 'react-redux';
// import { RootState } from '../../../../../../../store';
// import { localStorageEnum } from '../../../../../../../api/enums';

const index = () => {
  const { singleSafelockDataQ, safelockTransactionsQ, breakSafelock, paySafelockInterest, isLoading } = useSafeLock();
  const [formatedSLData, setFormatedSLData] = useState<FormattedSLData | null>(null);
  const params = useParams();
  const safelockID = params.safelockId as string;
  const [showActionModal, setShowActionModal] = useState(false);
  const [actionType, setActionType] = useState<'break' | 'payInterest' | null>(null);
  const [activeHistoryTab, setActiveHistoryTab] = useState<'transactions' | 'safelock-history'>('transactions');

  const activeCurrency = 'ngn';

  function formatAmount(value: number) {
    const balance = formatToNaira(value);
    if (activeCurrency === 'ngn') {
      return balance;
    } else {
      return balance.replace('₦', '$');
    }
  }
  function formatSafelockData(data: any): FormattedSLData {
    const slData = {
      Initial_Deposit: formatAmount(data.asls_initial_amount),
      Total_Interest_Earned: formatAmount(data.asls_interest_amount),
      Payback_Date: formatDate(data.asls_payout_date ?? data.asls_paydate).readableDate,
      Start_Date: formatDate(data.asls_date).readableDate,
      Initial_Interest_Earned: data.asls_interest + '%',
      Status: data.asls_status === 0 ? 'Ongoing' : 'Matured',
      Safelock_ID: data.asls_rand,
      Days_Left: data.asls_paydate - data.asls_date,
      Payback_Time: formatDate(data.asls_payout_date ?? data.asls_paydate).time,
      title: data.asls_title || 'Safelock Details',
      ...(data.asls_data
        ? {
            interest_Type: JSON.parse(data.asls_data)?.interestAtMaturity ? 'At Maturity' : 'Upfront',
          }
        : {
            interest_Type: 'Upfront',
          }),
    };

    if (data.asls_paydate * 1000 < Date.now()) {
      slData.Days_Left = 0;
    } else {
      const daysleft = (data.asls_paydate * 1000 - Date.now()) / (1000 * 60 * 60 * 24);
      slData.Days_Left = parseInt(daysleft.toString().split('.')[0]);
    }

    const slUIdata = Object.entries(slData);
    return {
      slData,
      slUIdata,
    };
  }

  useEffect(() => {
    if (singleSafelockDataQ) {
      const { slData, slUIdata } = formatSafelockData(singleSafelockDataQ);
      setFormatedSLData({
        slData,
        slUIdata,
      });
    }
  }, [singleSafelockDataQ]);

  const handleAction = (password: string) => {
    const payload = authPayload(password);

    if (actionType === 'break') {
      breakSafelock(safelockID, payload, () => {
        setShowActionModal(false);
      });
    } else if (actionType === 'payInterest') {
      paySafelockInterest(safelockID, payload, () => {
        setShowActionModal(false);
      });
    }
  };

  const showBreakSafelockButton =
    localStorage.getItem(localStorageEnum['local.storage.userId']) === '82c2277ef71119' ||
    localStorage.getItem(localStorageEnum['local.storage.userId']) === '7d0ca1bde4';

  return (
    <div className="single-target-page">
      <Header name="Single Safelock" backButton />

      <div className="content">
        <div className="target-header">
          <div className="left-section">
            <h1>
              {`Safelock Name - ${formatedSLData?.slData.title ?? ''}`}
              {singleSafelockDataQ?.isRollover && <span className="rollover-badge">Rolled Over</span>}
            </h1>
            <div className="id-container">
              <span className="flex--2 cont">
                <p>Safelock ID: {safelockID} </p>
                <IoCopyOutline
                  size={18}
                  className="pointer"
                  onClick={() => copyToClipboard('Safelock ID', safelockID)}
                />{' '}
              </span>
              {singleSafelockDataQ?.asls_status === 0 && showBreakSafelockButton && (
                <button
                  className="break-button flex--2 cont"
                  onClick={() => {
                    setActionType('break');
                    setShowActionModal(true);
                  }}
                >
                  {isLoading && actionType === 'break' ? 'Breaking...' : 'Break'}
                </button>
              )}
              {singleSafelockDataQ?.asls_status === 0 &&
                JSON.parse(singleSafelockDataQ?.asls_data || '{}')?.interestAtMaturity && (
                  <button
                    className="pay-interest-button flex--2 cont"
                    onClick={() => {
                      setActionType('payInterest');
                      setShowActionModal(true);
                    }}
                    disabled={true}
                    style={{
                      marginLeft: '10px',
                      backgroundColor: '#1734CA',
                      color: 'white',
                      padding: '8px 16px',
                      borderRadius: '8px',
                      cursor: 'not-allowed',
                    }}
                  >
                    {isLoading && actionType === 'payInterest' ? 'Processing...' : 'Pay Interest'}
                  </button>
                )}
            </div>

            {/* <div className="flex--2">
              <p>User ID: {id}</p>
              <IoCopyOutline size={18} className="pointer" onClick={() => copyToClipboard('User ID', id)} />
            </div> */}
          </div>
          {/* <div className="right-section">
            <QuickActions activeTabWallet="safelock" isWalletTab={false} />
          </div> */}
        </div>

        <div className="safelock-data">
          {formatedSLData?.slUIdata?.map((data) => {
            return (
              <div className="data-box" key={data[0]}>
                <p>{data[0].replaceAll('_', ' ')}</p>
                <h3>{data[1]}</h3>
              </div>
            );
          })}
        </div>

        <div className="history-tab-switch safelock">
          <span
            className={`history-pill${activeHistoryTab === 'transactions' ? ' active' : ''}`}
            onClick={() => setActiveHistoryTab('transactions')}
          >
            Transaction History
          </span>
          <span
            className={`history-pill${activeHistoryTab === 'safelock-history' ? ' active' : ''}`}
            onClick={() => setActiveHistoryTab('safelock-history')}
          >
            Safelock History
          </span>
        </div>

        {activeHistoryTab === 'transactions' && (
          <>
            <div className="customers-filter">
              <div className="input-field">
                <form action="" onSubmit={() => {}}>
                  <input type="text" placeholder="Search by Transaction ID, date" />
                </form>
              </div>
              <div className="query-filter">
                <div>
                  <svg width="10" height="10" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M0.75 0.75H17.25M6.75 13.25H11.25M3.75 7H14.25"
                      stroke="#1E293B"
                      strokeWidth="1.5"
                      strokeLinecap="square"
                    />
                  </svg>
                </div>
                <div>Search</div>
              </div>
              <div className="query-filter">
                <div></div>
                <div>Reset</div>
              </div>
            </div>

            {safelockTransactionsQ?.length ? (
              <div className="table-container single-safelock">
                <table className="table">
                  <thead className="table_head">
                    <tr>
                      <th className="date">Date</th>
                      <th className="amount">{`Amount (₦)`}</th>
                      <th className="balance">{`Balance (₦)`}</th>
                      <th className="memo">Memo</th>
                      <th className="type">Type</th>
                    </tr>
                  </thead>

                  <tbody className="table-body">
                    {safelockTransactionsQ.map((txn: any, index: any) => {
                      const ts = Number(txn.date);
                      const dateMoment = !ts ? null : ts > 1e12 ? dayjs(ts) : dayjs.unix(ts);
                      return (
                        <tr key={index} className="table-row" onClick={() => {}}>
                          <td>{dateMoment ? dateMoment.format('D MMM YYYY | h:mm A') : '-----'}</td>
                          <td>{txn.amount}</td>
                          <td>{txn.balance}</td>
                          <td className="memo">{txn.memo}</td>
                          <td>{txn.type}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <NoData message={'No transaction at the moment.'} />
            )}
          </>
        )}

        {activeHistoryTab === 'safelock-history' && (
          <>
            {singleSafelockDataQ?.safelockHistory?.length ? (
              <div className="table-container single-safelock">
                <table className="table">
                  <thead className="table_head">
                    <tr>
                      <th className="date">Date</th>
                      <th>Action</th>
                      <th>Name</th>
                      <th>Reference</th>
                      <th>Value</th>
                    </tr>
                  </thead>

                  <tbody className="table-body">
                    {singleSafelockDataQ.safelockHistory.map((entry: any, idx: number) => {
                      const ts = Number(entry.apa_date);
                      const dateMoment = !ts ? null : ts > 1e12 ? dayjs(ts) : dayjs.unix(ts);
                      return (
                        <tr key={idx} className="table-row">
                          <td>{dateMoment ? dateMoment.format('D MMM YYYY | h:mm A') : '-----'}</td>
                          <td>{entry.apa_action || '-----'}</td>
                          <td>{entry.apa_name || '-----'}</td>
                          <td>{entry.apa_rand || '-----'}</td>
                          <td>{entry.apa_value ?? '-----'}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <NoData message={'No safelock history at the moment.'} />
            )}
          </>
        )}
      </div>

      <ModalExecuteAction
        modalIsOpen={showActionModal}
        isLoading={isLoading}
        setIsOpen={setShowActionModal}
        text={actionType === 'break' ? 'break this safelock?' : 'pay interest for this safelock?'}
        action={(password: string) => handleAction(password)}
        actionColor="#1734CA"
        buttonText={actionType === 'break' ? 'Yes Break' : 'Yes Pay Interest'}
      />
    </div>
  );
};

export default index;
